export default __webpack_public_path__ + "static/media/node_js_logo.67ddd61a.png";